export const environment = {
  production: true,
  SW: true,
  URL_FRONT: 'https://centralremuneraciones.corporacionsofofa.cl',
  OTHERS: {
  },
  API_DOMAINS: {
    URL_USER: '',
    OTIC_CR: 'https://api-corp-cent-rem.corporacionsofofa.cl/cent-remu',
    USUARIOS: 'https://api-corp-cent-rem.corporacionsofofa.cl/usuarios',
    COMUNES: 'https://api-corp-cent-rem.corporacionsofofa.cl/comunes',
  },
  AUTH_DOMAIN: 'https://centralremuneraciones.corporacionsofofa.cl',
  sso: {
    realm: 'CORPORACION',
    url: 'https://sso-prod.corporacionsofofa.cl',
    sslRequired: 'external',
    resource: 'centralizacion-front',
    publicClient: true,
    confidentialPort: 0,
  },
  push: {
    vapidPublicKey:
      'BJ81JiROOOdvwk9s3gOKi0t37zFFKYtzlhX8kLvKjJkc3f1sDqYi1OV54T9YSuFXbI8HrYUnneke5ycJncsxQTc',
  },
};
